export default __webpack_public_path__ + "static/media/ms-products.369601e8.svg";